import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import {
  Button,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material' // Import Material UI icons

import { Player } from '@lottiefiles/react-lottie-player' // Import Lottie player component
import { Link, Navigate } from 'react-router-dom' // Import Link from router

import { useTranslation } from 'react-i18next' // Import i18n translation hook
import routes from '../router/routes' // Import routes definition
import useRouter from '../hooks/use-router' // Import custom hook for driver profile

const HomePage = () => {
  const { data, isLoading } = useRouter()
  const { t } = useTranslation() // Get translation function
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))

  if (isLoading) {
    return (
      <Grid
        alignContent="center"
        container
        direction="column"
        justifyContent="center"
        rowGap={0}
        spacing={0}
        sx={{
          height: '90vh',
          p: 2,
        }}
      >
        <CircularProgress />
      </Grid>
    )
  }

  if (data?.status === 'active') {
    return <Navigate to={routes.portal.profile} />
  }

  return (
    <Grid
      container
      direction="column"
      sx={{
        p: 2,
      }}
    >
      <Grid
        item
        md={4}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
        textAlign="center"
        xs={12}
      >
        <Grid
          container
          sx={{
            py: 4,
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h3">{t('homepage.welcome')}</Typography>
            <Typography variant="subtitle1">
              {`${data?.first_name} ${data?.last_name}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Player
              autoplay
              loop
              src="https://assets4.lottiefiles.com/packages/lf20_puciaact.json"
              style={{ height: '300px', width: '300px' }}
            />
          </Grid>
          <Grid item textAlign="center" xs={12}>
            <Typography variant="subtitle1">{t('homepage.tagline')}</Typography>
          </Grid>
          <Grid item textAlign={isLargeScreen ? 'center' : 'left'} xs={12}>
            <Typography paragraph variant="body1">
              {t('homepage.description_1')}
              {isLargeScreen ? <br /> : ` `}
              {t('homepage.description_2')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              component={Link}
              disableElevation
              endIcon={<ArrowForwardIcon />}
              to={routes.portal.documents}
              variant="contained"
            >
              {t('homepage.cta')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HomePage
